import { Flex, Text } from '@chakra-ui/react';
import TrialProgressBox from './TrialProgressBox';

function PageHeadingWithTrialProgress({
  title,
  buttonVariant = 'gradient',
  titleProps,
  displayTrialProgress = true,
}) {
  return (
    <Flex
      direction={{
        base: 'column-reverse',
        xl: 'row',
      }}
      alignItems={{ base: 'flex-start', xl: 'center' }}
      mt="10px"
      py="9px"
      minH="54px"
      justifyContent="space-between"
      w="100%"
    >
      <Text
        textStyle="heading2"
        textAlign={{ base: 'center', md: 'left' }}
        {...titleProps}
      >
        {title}
      </Text>
      {displayTrialProgress && (
        <TrialProgressBox buttonVariant={buttonVariant} />
      )}
    </Flex>
  );
}

export default PageHeadingWithTrialProgress;
